import { render } from "./AppTopbar.vue?vue&type=template&id=72ea9863&ts=true"
import script from "./AppTopbar.vue?vue&type=script&lang=ts"
export * from "./AppTopbar.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__